module.exports = __webpack_public_path__ + "media/images/partnership-categories-empty-3ecc1f0ed96b362d50ab199137b7949b.png";